import React, { useEffect, useRef } from "react";
import translate from "@deosite/helpers/langLibrary";

import Box from "@commerce-ui/core2/Box";
import Grid from "@commerce-ui/core2/Grid";
import Container from "@commerce-ui/core2/Container";
import Image from "@deosite/components-new/Image";

import PageContainer from "../../containers/UI/PageContainer";

import InspirationHeader from "../../components/InspirationHeader";
import InfluencerBio from "../../components/InfluencerBio";
import MinifiedProductPanel from "../../components/MinifiedProductPanel";
import InspirationCard from "../../components/InspirationCard";

import SectionWithConfigurableHeader from "../../sections/SectionWithConfigurableHeader";
import Grid2Cards from "../../sections/Grid2Cards";

const InspirationPage = props => {
  const {
    categoryProducts,
    backLabel,
    backClickFunction,
    footerContent,
    dataRequiredToHideLoader,
    prismicData,
    addToCartDisabled
  } = props;

  const translations = {
    seoDescription: translate("Default seo description"),
    seoTitle: translate("Default seo title"),
    peopleLiked: translate("People also liked")
  };

  return (
    <PageContainer
      footerContent={footerContent}
      returnLinkLabel={backLabel}
      onReturnLabelClick={backClickFunction}
      minifiedMargin={true}
      metaTagsData={{
        description: translations.seoDescription,
        title: translations.seoTitle
      }}
      dataRequiredToHideLoader={dataRequiredToHideLoader}
    >
      <Container>
        <Grid cols={[1, 1, 20, 20, 20]}>
          {prismicData?.content?.inspirationPage ? (
            <Box
              sx={{
                gridColumn: ["span 2", null, "span 9", null]
              }}
            >
              <Box
                sx={{
                  display: ["block", null, null, "none"],
                  mb: "s10"
                }}
              >
                {prismicData?.content && (
                  <InspirationHeader
                    inspiration={prismicData.content.inspirationPage[0]}
                  />
                )}
              </Box>
              <Box
                sx={{
                  position: "sticky",
                  top: "172px"
                }}
              >
                <Image image={prismicData.content.inspirationPage[0].image} />
              </Box>
            </Box>
          ) : (
            <Box />
          )}
          <Box
            sx={{
              gridColumn: ["span 0", null, "span 1", null]
            }}
          />
          <Box
            sx={{
              gridColumn: ["span 2", null, "span 10", null]
            }}
          >
            <Box
              sx={{
                display: ["none", null, null, "block"]
              }}
            >
              {prismicData?.content?.inspirationPage && (
                <InspirationHeader
                  inspiration={prismicData.content.inspirationPage[0]}
                />
              )}
            </Box>
            <Box
              sx={{
                mt: "s11",
                mb: "s10"
              }}
            >
              {categoryProducts.map((product, index) => (
                <Box
                  sx={{
                    mt: "s9"
                  }}
                >
                  <MinifiedProductPanel
                    showOptionsSelector={false}
                    key={index}
                    product={product}
                    addToCartDisabled={addToCartDisabled}
                  />
                </Box>
              ))}
            </Box>
            {prismicData?.content?.inspirationPage && (
              <InfluencerBio
                influencerData={
                  prismicData.content.inspirationPage[0].influencerData
                }
              />
            )}
          </Box>
        </Grid>
      </Container>
      {prismicData?.content?.inspirations && (
        <SectionWithConfigurableHeader title={translations.peopleLiked}>
          <Container>
            <Grid2Cards>
              {prismicData.content.inspirations.map(
                (inspiration, index) =>
                  inspiration && (
                    <Box
                      sx={{
                        marginTop: index > 1 ? "s11" : 0,
                        width: "100%"
                      }}
                      key={index}
                    >
                      <InspirationCard inspiration={inspiration} key={index} />
                    </Box>
                  )
              )}
            </Grid2Cards>
          </Container>
        </SectionWithConfigurableHeader>
      )}
    </PageContainer>
  );
};

export default InspirationPage;
